(() => {
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initReveal = (root = document) => {
    const els = [...root.querySelectorAll('.rydar-reveal:not([data-rydar-reveal-bound])')];
    if (!els.length) return;
    if (reducedMotion() || !('IntersectionObserver' in window)) {
      els.forEach(el => { el.classList.add('is-visible'); el.dataset.rydarRevealBound = '1'; });
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(el => { el.dataset.rydarRevealBound = '1'; io.observe(el); });
  };

  const setLightState = (section, state) => {
    section.querySelectorAll('.rydar-lights__img').forEach(img => img.classList.toggle('is-active', img.dataset.state === state));
    section.querySelectorAll('.rydar-light-step').forEach(step => step.classList.toggle('is-active', step.dataset.state === state));
    section.querySelectorAll('.rydar-light-tab').forEach(tab => tab.classList.toggle('is-active', tab.dataset.state === state));
  };

  const initLights = (root = document) => {
    root.querySelectorAll('[data-rydar-lights]:not([data-rydar-lights-bound])').forEach(section => {
      section.dataset.rydarLightsBound = '1';
      const steps = [...section.querySelectorAll('.rydar-light-step')];
      if (!steps.length) return;
      setLightState(section, 'green');

      section.querySelectorAll('.rydar-light-tab').forEach(tab => tab.addEventListener('click', () => setLightState(section, tab.dataset.state)));

      let ticking = false;
      const updateFromScroll = () => {
        ticking = false;
        if (window.innerWidth < 990) return;
        const targetY = window.innerHeight * 0.5;
        let best = steps[0];
        let bestDistance = Infinity;
        steps.forEach(step => {
          const r = step.getBoundingClientRect();
          const center = r.top + r.height / 2;
          const d = Math.abs(center - targetY);
          if (d < bestDistance) { bestDistance = d; best = step; }
        });
        setLightState(section, best.dataset.state);
      };
      const onScroll = () => {
        if (!ticking) { ticking = true; requestAnimationFrame(updateFromScroll); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      updateFromScroll();
    });
  };

  const initAnchors = (root = document) => {
    root.querySelectorAll('a[href^="#rydar-"]').forEach(a => {
      if (a.dataset.rydarAnchorBound) return;
      a.dataset.rydarAnchorBound = '1';
      a.addEventListener('click', e => {
        const target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        const header = document.querySelector('sticky-header, .header-wrapper, header');
        const offset = header ? header.getBoundingClientRect().height + 12 : 12;
        const y = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: y, behavior: reducedMotion() ? 'auto' : 'smooth' });
      });
    });
  };

  const init = (root = document) => { initReveal(root); initLights(root); initAnchors(root); };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
